import axios from "axios";
import Cookies from "js-cookie";

// L-01 (MA-06): auth now travels via the httpOnly mantis_session cookie, not a
// Bearer header built from a localStorage-readable token. Mutating requests still
// need the CSRF header, read from the non-httpOnly csrfToken cookie.
const MUTATING_METHODS = new Set(["post", "put", "patch", "delete"]);

const axiosWithAuth = axios.create({ withCredentials: true });

axiosWithAuth.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (MUTATING_METHODS.has(method)) {
    const csrfToken = Cookies.get("csrfToken");
    if (csrfToken) {
      config.headers = config.headers || {};
      for (const key of Object.keys(config.headers)) {
        if (key.toLowerCase() === "x-csrf-token") {
          delete config.headers[key];
        }
      }
      config.headers["X-CSRF-Token"] = csrfToken;
    }
  }
  return config;
});

export default axiosWithAuth;
